var dynamicFooterHeight;
function HideIns() {
    var substractFromGridHeight = 20;
    if (276 < gridHeight){
        substractFromGridHeight = 80;
    }
    if ($('.datagrid-footer').is(":visible") == true) {
        $('.datagrid-footer').hide();
        $('.datagrid-wrap').height( $('.datagrid-wrap').height() - substractFromGridHeight);
        $('.datagrid-view').height($('.datagrid-wrap').height() - substractFromGridHeight);
    }
}

function ShowIns() {
    $('#highlow-inspector,#surprise-inspector').removeClass('custom-label-selected');
    if (high_low_src != "") {
        //set high/low on
        $('#highlow-inspector').addClass('custom-label-selected');
    }
    if (typeof surprise != "undefined" && surprise != "") {
        //set surprise on
        $('#surprise-inspector').addClass('custom-label-selected');
    }

    if ($('.datagrid-footer').is(":visible") == false) {
        $('.datagrid-footer').show();
    }
}
function getPeriodsForInspector() {
    var periodPanel = MEData.panels.getValues('name', 'periods')[0];
    var completePeriods = [];
    var quarterPeriods = [];
    var fromPeriod = getYear(periodPanel.from);
    var defaultData = MEData.column_dimensions[0].expansions[1];
    for (var i = fromPeriod; i <= getYear(periodPanel.to); i++) {
        var periodString = periodPanel.from.replace(fromPeriod, i);
        completePeriods.push(periodString);
        for (var i = 0; i < defaultData.length; i++) {
            if (calendarYears)
                quarterPeriods.push(defaultData[i] + '$$' + periodString);
            else
                quarterPeriods.push(defaultData[i] + periodString);
        };
    }
    return {'annual': completePeriods, 'quarter': quarterPeriods};
}
function appendInspectorSettings(inspDataObj) {
    if ($('.datagrid-custom-div').length > 0)
        return;
    $('.datagrid-body').after('<div class="datagrid-custom-div"></div>');
    if (!jQuery.isEmptyObject(inspDataObj)) {
        $('.datagrid-view1 .datagrid-custom-div').attr('id', 'customDiv1');
        $('.datagrid-view2 .datagrid-custom-div').attr('id', 'customDiv2');
        var closeInspector1 = '<div class = "closeInsDiv"><img class="arrow-circle-down inspector-arrow" src="'+ window.assetUrl +'/circular_arrow_down.png" alt="Down">'
        var closeInspector2 = '<span class="tblInsSpan"></span></div>';
        var inspectorTypesDiv = footerTypes();
        var inspectorDiv1 = $('#customDiv1');
        $(closeInspector1 + closeInspector2 + '<div style="height:35px"></div>').appendTo(inspectorDiv1);
        var inspectorSettingDiv1 = '<div class = "settingDiv1"></div>';
        var inspectorSettingDiv2 = '<div class = "settingDiv2"></div>';
        var inspectorDiv2 = $('#customDiv2');
        $(inspectorSettingDiv1 + inspectorSettingDiv2).appendTo(inspectorDiv2);

        var setting1 = $('#customDiv2 .settingDiv1');
        $(inspectorTypesDiv).appendTo(setting1);
        clickToAddEvent(setting1);
        $('.closeInsDiv .inspector-arrow').bind('click', function () {
            InspectorClick(true, "inspector-header", "inspector");
        });
    }
    else {
        $('#tblIns').find('img').hide();
    }
    //create div and include setting data in inspector
    var settingDiv1 = $('.settingDiv1');
    var settingDiv2 = $('.settingDiv2');
    var tableInsp = $('#tblIns');

    //removing inspector displaying text on the right
    // $('<span class="lineInfoRight"></span><div id="infoDiv" class="inspDiv"></div>').appendTo(settingDiv1);
    // $('<span class="tblInsSpan"></span><div id="infoDiv" class="inspDiv"></div>').appendTo(tableInsp);
    $('<span class="tblInsSpan"></span>').appendTo(tableInsp);
    //temporary
    $('.inspDiv').text('Displaying: Bull,Bear, Variant A');

    //append highlow and surprise tabs
    $('<div class="custom-labels-container" id="inspector-labels"></div>').appendTo(settingDiv2);
    var labelsContainer=$('#inspector-labels');
    $('<div class="custom-label first" id="highlow-inspector"><span class="custom-label-text">High/Low</span></div>').appendTo(labelsContainer);
    $('<div class="custom-label last" id="surprise-inspector"><span class="custom-label-text">Surprise</span></div>').appendTo(labelsContainer);
}
function bindHideEventToFooter() {
    $('.datagrid-footer').bind('hide', function () {
        
        setTimeout("afterFooterHide();", 10);
    });
    $('.datagrid-footer').bind('show', function () {
   
        setTimeout("afterFooterShow();", 10);

    });
}

function afterFooterHide() {
    if ($('.datagrid-footer').is(":visible"))
        return;
    $('.datagrid-custom-div').hide();
}

function afterFooterShow() {
    if (!$('.datagrid-footer').is(":visible"))
        return;
    $('.datagrid-custom-div').show();
}
function footerCommonsizeData(lineData, objParameter){
    var baseValues = lineData.filter(function(i,el){
        var keyInParts = i.key.split('|');
        var param = keyInParts[3];
        return (param == MEData.baseparameter.id);
    })
    for (var indexdata = 0; indexdata < baseValues.length; indexdata++) {
        var valuedata = baseValues[indexdata];
        var keyInParts = valuedata.key.split('|');
            valuedata.source = keyInParts[0];
            valuedata.period = keyInParts[2];
            valuedata.growthtype = keyInParts[5];
            valuedata.param = keyInParts[3];
        var objRowField = MEData.baseparameter.id + valuedata[footerRowDimension[1]].toLowerCase();
        dataValue = valuedata.data[0];
        var objColField = "";
        for (var indexcol = 0; indexcol < colDimension.length; indexcol++) {
            var valuecol = colDimension[indexcol]; 
            if (colDimension[indexcol] != footerRowDimension[1]) {
                objColField = objColField + valuedata[valuecol].toLowerCase();
            } else {
                objColField = objColField + defaultValue;
            }
        };
        if(sourcesExist && whetherIsForecast(valuedata.period))
            objColField = objColField.replace(gSourceActual.toLowerCase(),gSourceFuture.toLowerCase());
        baseColumnData = baseParameterValues.filter(function(baseValue , baseIndex){
            if(baseValue.column == objColField)
                return baseValue;
        });
        baseParamValue = baseColumnData[0];
        if(baseParamValue == undefined)
            continue;
        if(valuedata.data.length == 0){
            obj = { "column": objColField, "text": "", 'negative':false,"dpid": 0};
            baseParamValue[objRowField] = obj;
            continue;
        }
        text = dataValue.value;
        var baseDpId = dataValue.id;
        if(text && text.indexOf('-') > -1) {
            text = text.replace('-','');
            obj = { "column": objColField, "text": text, 'negative':true,"dpid": baseDpId};
        }
        else
            obj = { "column": objColField, "text": text, 'negative':false ,"dpid": baseDpId};
        baseParamValue[objRowField] = obj;
    };
    var notBaseValues = lineData.filter(function(i,el){
        var keyInParts = i.key.split('|');
        var param = keyInParts[3];
        return (param == objParameter.paramid);
    });
    return notBaseValues;
}
function OnSucessLoadDatagridFooterData(lineItemData, objParameter) {
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(3);
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
    var lastQClassArr = [];
    var rowObj = objParameter.footerRows;
    var baseParamRow = ($.inArray(objParameter.paramid, baseParamLineitems) > -1) ? true : false;
    if (objParameter.baseData)
        var responseData = footerCommonsizeData(lineItemData.data, objParameter) || [];
    else
        var responseData = lineItemData.data || [];
    for (var indexdata = 0; indexdata < responseData.length; indexdata++) {
        var valuedata = responseData[indexdata];
        var keyInParts = valuedata.key.split('|');
            valuedata.source = keyInParts[0];
            valuedata.period = keyInParts[2];
            valuedata.growthtype = keyInParts[5];
            valuedata.param = keyInParts[3];
            valuedata.ticker = keyInParts[1];

            baseParamRow = ($.inArray(valuedata.param, baseParamLineitems) > -1) ? true : false;
        var objRowField = objParameter.paramid + valuedata[footerRowDimension[1]].toLowerCase();
        var i = undefined;
        for (var index = 0; index < rowObj.length; index++) {
            var el = rowObj[index];
            if (el.id == objRowField) {
                i = index;
                break;
            }
        };
        for (var indexrowdata = 0; indexrowdata < valuedata.data.length; indexrowdata++) {
            var valuerowdata = valuedata.data[indexrowdata];
            var objColField = "";
            for (var indexcol = 0; indexcol < colDimension.length; indexcol++) {
                var valuecol = colDimension[indexcol];
                if (colDimension[indexcol] != footerRowDimension[1]) {
                    objColField = objColField + valuedata[valuecol].toLowerCase();
                } else {
                    if (sourcesExist && whetherIsForecast(valuedata.period))
                        objColField = objColField + replaceConsensusPlusOperator(gSourceFuture.toLowerCase());
                    else
                        objColField = objColField + replaceConsensusPlusOperator(gSourceActual.toLowerCase());
                }
            };
            objColField = replaceConsensusPlusOperator(objColField);
            var tdEle = table2.eq(i).find("td[field='" + objColField + "']");
            if (tdEle.length > 0) {
                if (valuerowdata.unit){
                    var htmlVal = formatValue(valuerowdata.value, valuerowdata.param_id, objColField, {
                        'unit': valuerowdata.unit,
                        'precision': valuerowdata.precision
                    });
                } else {
                    var htmlVal = formatValue(valuerowdata.value, valuerowdata.param_id, objColField, {'precision': valuerowdata.precision});
                }
                tdEle.find('div').html(htmlVal);
                tdEle.attr('id', valuerowdata.id);
                tdEle.attr('period', valuerowdata.period);
                tdEle.attr('dapparam_id', valuerowdata.param_id);
                tdEle.attr('source', valuedata.source);
                if(tdEle.hasClass('lastQ') || table1.find('td[field^="' + objColField + '"]').hasClass('lastQ')){
                    lastQClassArr.push(objColField);
                }
                
                tdEle.removeClass();
                getCellStyling(valuerowdata.annotation, tdEle);
                // if (valuerowdata.dpnote && $(tdEle).attr('note') == undefined) {
                //     //change here
                //     bindPopoverForNotes(valuerowdata.dpnote,$(tdEle),objColField);

                //     if(valuerowdata.internal_note){
                //         $(tdEle).addClass('internal_note');
                //     } else {
                //         $(tdEle).addClass('external_note');
                //     }
                // }

                if(objParameter.callFor === 'Peers'){
                    tdEle.attr('ticker', valuedata.ticker);
                }
                if (valuerowdata.max) {
                    $(tdEle).attr('max', '');
                }
                if (valuerowdata.min) {
                    $(tdEle).attr('min', '');
                }
                if (valuerowdata.surprise != undefined) {
                    $(tdEle).attr('surprise', valuerowdata.surprise);
                    $(tdEle).attr('title', valuerowdata.title);
                }
                if(htmlVal != ''){
                var notesObj = {
                    parameterid: objParameter.parameterid,
                    period:valuerowdata.period,
                    source: valuedata.source,
                    revision:{
                        revision: valuedata.revision,
                        revision_date: valuedata.revision_date,
                        revision_datetime: valuedata.revision_datetime,
                    },
                    el: tdEle
                }
                bindDataPointNote(notesObj);
                }
            }
            if (!baseParamValue) {
                var baseParamValue = {};
            }
            appendValuesInBaseParameter(valuerowdata, baseParamValue, objColField, objRowField);
            if (dataInCommonsize && baseParamRow) {
                baseColumnData = $.grep(baseParameterValues, function (baseValue, baseIndex) {
                    if (baseValue.column == objColField)
                        return baseValue;
                });
                baseParamValue = baseColumnData[0];
                rowfield = objRowField.replace(objParameter.paramid, MEData.baseparameter.id);
                if (baseParamValue != undefined)
                    baseParamValue = baseParamValue[rowfield];
                var valueData = valuerowdata.value;
                if (+valueData < 0)
                    valueData = "(" + valueData.replace('-', '') + ")";
                cellCommonsize(tdEle[0], true, baseParamValue, false, valueData + "");
            }
        };
    };
    

    //loop on all cols with lastQ class present already
    for(var i =0 ;i<lastQClassArr.length; i++){
        table2.find("td[field='" + lastQClassArr[i] + "']").addClass('lastQ');
    }
}
function abortInspctorCalls() {
    if (ajaxCalls.inspectorCalls) {
        for (var i = 0; i < ajaxCalls.inspectorCalls.length; i++) {
            var el = ajaxCalls.inspectorCalls[i];
            if (el.readyState != 4)
                el.abort();
        };
    }
}

var footerRowDimension = [], inspectorType = "";
function LoadDatagridFooterData(index, type, logEvent, from) {

    //don't proceed if the tab is already open
    var selectedTabId = $('#footerTypeDiv .fstddivclick').eq(0).attr('id');
    var selectedTabAlreadyExpanded = selectedTabId && !$('#tblIns').is(":visible") && selectedTabId.includes(type);
    if(from !== "rowClick"  && index !== 0 && selectedTabAlreadyExpanded) {
        return;
    }
    if(from === "tabClick" && index === 0 && selectedTabAlreadyExpanded) {
        return;
    }
    
    var selectedRow = $('#tt').datagrid('getSelected');
    if(window.prevSelectedRow 
        && prevSelectedRow.id.split("-")[0] === selectedRow.id.split("-")[0]
        && selectedTabAlreadyExpanded) {
        return;
    }
    
    $(".mex-grid-table-component #tblIns #footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
    $(".line-item-details-container").remove();
    $(".comptable-container").remove();
    $('.datagrid-footer').css('display', 'block');
    $('.datagrid-footer-inner').css('display', 'block');
    $('.datagrid-custom-div').css('display', 'block');
    $(".datagrid-view2 .settingDiv2").show();
    $(".datagrid-view1 #customDiv1 div").eq(1).show();
    if($(".mex-grid-table-component #tblIns").is(":visible")) {
        prevSelectedRow = undefined;
        InspectorClick(true, type, from);
        return;
    }

    var selectedRow = $('#tt').datagrid('getSelected');
    prevSelectedRow = selectedRow;
    if(type === "Peers" && !$(".compareToPeerIcon-"+selectedRow.id.split("-")[0]).is(":visible")) {
        type = "Lineitem";
    }

    if(from == 'peers' && !event.target.closest(".datagrid-row-selected")){
        // to prevent double api calls
        return false;
    }
    abortInspctorCalls();

    if (logEvent) {
        dummyAjaxRequest(company, cut, 'INSPECTOR_TAB_CHANGE', type);
    }

    if(type === "Lineitem") {
        LoadFooterWithLineItemDetails(type);
        return;
    }

    if(type === "Comptable") {
        LoadFooterWithComptable(index, type, logEvent, from)
        return;
    }

    if(type == "Peers") {
        LoadFooterWithPeers(index, type);
        return;
    }
    var param_id = "";
    if (inspectorType != "" && inspectorType != type) {
        rowclicked = false;
    }
    inspectorType = type;
    var selected = $('#tt').datagrid('getSelected');
    if (selected == null)//&& (!rowclicked)
    {
        var dgRows = $('#tt').datagrid('getRows');
        selected = dgRows[index];
    }
    //to empty values already existing in the footer
    $('#tt').datagrid("getPanel").find('table').eq(5).find('td').removeAttr("note").removeClass().find('div').text("").removeAttr("note").unbind('mouseover');

    //we have to stop if inspector is clicked double time for same line
    if (selected) {
        param_id = selected.id.split("-")[0];
        if(MEData.row_dimensions[0].values.getValues('header', true).getKeyValues('id').includes(param_id)){
            var dgRows = $('#tt').datagrid('getRows');
            param_id = MEData.row_dimensions[0].values.getValues('header', undefined).getKeyValues('id')[0];
            dgRows.map(function (el,i ) {
                if (el.id.split("-")[0] == param_id) {
                    selected = el;
                    $('#tt').datagrid('selectRow', i);
                    return false;
                }
            });
        }
        var selectedType = rowDefaults[type.toLowerCase().substring(0, type.length - 1)];
        if (!selectedType || selectedType == "")
            selectedType = selected.name;
        var footerrows = [];
        var filterObj = GetFilterData(type, selectedType);
        var filterData = filterObj.FilterData, defaultValue = filterObj.DefaultValue;
        for (var index = 0; index < filterData.length; index++) {
            var value = filterData[index];
            footerrows.push({lineitems: "<b>" + value + "</b>", "id": param_id + value.toLowerCase()});
        };
        //display lineitem on inspector
        displayLineitem(selected);
        if (!rowclicked || $("#TdPeers").length > 0) {
            footerRowDimension = [];
            $('#tt').datagrid('reloadFooter', footerrows);
            $('.datagrid-view1').find('td[field="lineitems"]').children().css('min-width','230px');
            var footerHeight = Math.min(parseInt($(".datagrid-footer-inner").height()), 120);
            $(".datagrid-footer").height(footerHeight + "px");

            $('.datagrid-footer').find('td[field="lineitems"]').eq(0).width('100%')
            $('.datagrid-body').height($('.datagrid-wrap').height() - $(".datagrid-footer").height() - $('.datagrid-header').height() - $('.datagrid-custom-div').height());
            dynamicFooterHeight = $('.datagrid-footer').height();
            footerRowDimension.push("lineitem");
            footerRowDimension.push(type.toLowerCase().substring(0, type.length - 1));
        }
        else {
            if ($('.datagrid-footer').is(":visible") == false) {
                ShowIns();
            }
        }
        rowclicked = true;
        var table1 = $('#tt').datagrid("getPanel").find('table').eq(2).find('tr');
        var table2 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
        removeHighLowAndSurpriseColoring(table2.find('td'));        
        table2.find('td').removeAttr('class');
        table1.eq(0).find('td').eq(0).find('span').attr('title', selectedType).html(selectedType);
        if ($.inArray(param_id, driverLines) > -1)
            table1.eq(0).find('td').eq(0).find('span').addClass('driver');
        else
            table1.eq(0).find('td').eq(0).find('span').removeClass('driver');
        var ObjWebServiceCall = new WebServiceCall();
        var objME = new ModelExplorer();
        try {
            rowindex = baseParamIndex(true, selected.id.split('-')[0]);
            dataTr = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr').eq(rowindex);
            table2.eq(0).find('td').removeClass("datagrid_expendedcolumn");
            clearRevisionColoringInspector();
            footerPeriods = periods.join('&period=');
            if (!$('#tblIns').is(":visible")) {
                if ($.inArray(footerPeriods, baseFooterColumns[type]) > -1)
                    ObjWebServiceCall.getFooterRowData(param_id, footerPeriods, type, filterData, "", {
                        "paramid": param_id,
                        "parameterid": selected.parameterid,
                        "footerRows": footerrows,
                        "baseData": false
                    });
                else {
                    baseFooterColumns[type].push(footerPeriods);
                    if (cut == 'SCH') {
                        periods.map(function (v, i) {
                            ObjWebServiceCall.getFooterRowData(param_id, "period=" + v, type, filterData, "", {
                                "paramid": param_id,
                                "parameterid": selected.parameterid,
                                "footerRows": footerrows,
                                "baseData": true
                            });
                        });
                    } else {
                        ObjWebServiceCall.getFooterRowData(param_id, "period=" + footerPeriods, type, filterData, "", {
                            "paramid": param_id,
                            "parameterid": selected.parameterid,
                            "footerRows": footerrows,
                            "baseData": true
                        });
                    }
                }
            }
        } catch (ex) {
        }
        if (!$('#tblIns').is(":visible"))
            GetLIColsExpandedValue();
    }
    $("#footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
    $("#Td" + type).attr("class", "fstdInspclick fstddivclick");
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() - 1);
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + 1);
}

function createLineItemDetail(title, value) {
    var lineItemDetail = $("<div class='line-item-detail' style='display: flex; margin-top: 10px; align-items: center;'></div>");
    var titleElem = $("<span style='font-weight: bold; width: 170px;'>" + title + "</span>");
    var width = isNaN(value) ? '250px' : '60px';
    var tooltip = isNaN(value) ? value : "";
    var valueElem = $("<span title='" + tooltip + "' style='margin-left: 12px; width: " + width + "; text-overflow: ellipsis; overflow: hidden;'>" + value + "</span>");
    var copyBtn = $("<span class='far fa fa-copy' style='margin-left: 12px; color:#8b8b8b; cursor: pointer;'></span>");
    lineItemDetail.append(titleElem, valueElem, copyBtn);
    
    copyBtn.on('click', function() {
        const copyValueToClipboard = new CustomEvent('copyValueToClipboard', {detail:{text: value } })
        window.dispatchEvent(copyValueToClipboard); 
    });

    var columnClass = isNaN(value) ? '.column-left' : '.column-right';
    $(".line-item-details-container " + columnClass).append(lineItemDetail);

    return lineItemDetail;

}

function createComptableMappingHeader() {
    var header = $("<div class='comptableInspHeader'> \
            <div class='comptableInspHeaderContent' style='width: 276px;'>Industry</div> \
            <div class='comptableInspHeaderContent' style='width: 400px;'>Comp Table Name</div> \
            <div class='comptableInspHeaderContent' style='flex-grow: 1;'>Link</div> \
        </div>");
    $(".comptable-container .table-header").append(header);
}

function createComptableLine(compTable) {

    var compTableLine = $("<div class='comptable-line comptableInspLine'></div>");

    var industry = $("<div class='comptableInspLineContent' title='" + compTable.industry_name + "' style='width: 276px;  border-right: 1px solid #e0e2e2;'>" + compTable.industry_name + "</div>");
    var name = $("<div class='comptableInspLineContent' title='" + compTable.label + "' style='width: 400px; border-right: 1px solid #e0e2e2;'>" + compTable.label + "</div>");
    var link = $("<div class='comptableInspLineContent' style='flex-grow; 1;'> <a target='_blank' href='/comparative-analysis/current?comp_type=system&id=" + compTable.shortName + "'> <span class='far fa fa-external-link'></span> </a> </div>");

    compTableLine.append(industry);
    compTableLine.append(name);
    compTableLine.append(link);

    $(".comptable-container .table-content").append(compTableLine);
    return compTableLine;
}

function getCompanyPeers(ticker, uniquesliid, onSuccess) {
    var params = [
        "ticker=" + ticker,
        "uniquesliid=" + uniquesliid,
        "limit=1",
        "peers_by_usli=true"
    ];

    $.ajax({
        type: "GET",
        async: true,
        url:  window.apiUrl + "/charts_page/get_company_peers?" + params.join("&"),
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        beforeSend: function (xhr) {
        },
        success: function (response) {
            if(response.status === "success") {
                onSuccess((response.peer_info && response.peer_info.length) ? true : false);
            }
        }
    })

}

function getComptableMappings(companyid, uniqueSliIds, onSuccess) {
    var params = ["companyid=" + companyid];
    uniqueSliIds.forEach(function(id) {
        params.push("uniquesliid=" + id);
    });

    $.ajax({
        type: "GET",
        async: true,
        url:  window.apiUrl + "/comps/get_comps_cid_and_usli?" + params.join("&"),
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        beforeSend: function (xhr) {
        },
        success: function (response) {
            if(response.status === "success") {
                onSuccess(response.data);
            } else {
                onSuccess([]);
            }
        }
    });
}

function setComptableTabState(compTables, param_id) {
  selectedLineStdAndCompDict[window.pg + param_id].comptableMappings = compTables;
  if(compTables.length > 0) {
      $("#footerTypeDiv #TdComptable").css('display','inherit');
  }else {
      if(window.inspectorType === "Comptable"){
          window.inspectorType = "Lineitem";
      }
  }
}

function fetchComptableMappings(stdMappings, param_id) {
  var uniqueSliIds = stdMappings.map(function(stdMapping){ return stdMapping[0]; });
  if(uniqueSliIds.length > 0) {
      getComptableMappings(window.MEData.companyid, uniqueSliIds, 
        function(data){
          setComptableTabState(data, param_id)
        });
  }else{
      setComptableTabState([], param_id);
  }
}

function GetLIColsExpandedValue() {
    if (ExpandedColList[colDimension.length - 1].length == 0){
        // for adding consitent borders to all footer tables
        $(".datagrid-footer table").eq(0).find('td[field=lineitems]').css("border-right-width", "0px");
        $(".datagrid-footer table").eq(0).find('td[field=links]').css("border-right-width", "0px");
        $(".datagrid-footer-inner").css("border", "none");
        $(".datagrid-footer-inner .datagrid-ftable").css("border", "1px solid #ddd");
        $(".datagrid-footer-inner .datagrid-ftable").css("border-width", "1px 0px 0px 0px");
        return;
    }
    var datagridbodyRows = $('div.datagrid-footer').find('table').eq(1).find('tr');
    var SelectedData = $('#tt').datagrid('getSelected');
    if (SelectedData == null) {
        var dgRows = $('#tt').datagrid('getRows');
        SelectedData = dgRows[0];
    }
    var selectedType = rowDefaults[inspectorType.toLowerCase().substring(0, inspectorType.length - 1)];
    if (!selectedType || selectedType == "")
        selectedType = SelectedData.name;
    var footerDatas = [];
    if(inspectorType == 'Peers') {
        filterData = peerData.tickers;
        for (var index = 0; index < filterData.length; index++) {
            var value = filterData[index];
            footerDatas.push({
                lineitems: '<b ' + 'title="' + value.name + ": " + value.param_name + '">' + value.ticker + ": " + value.param_name + "</b>",
                id: value.param + value.ticker.toLowerCase()
            });
        };

    }
    else {
        var filterObj = GetFilterData(inspectorType,selectedType);
        var filterData = filterObj.FilterData;
        for (var index = 0; index < filterData.length; index++) {
            var value = filterData[index];
            footerDatas.push({
                lineitems: "<b>" + value + "</b>",
                "id": SelectedData.id.split('-')[0] + value.toLowerCase()
            });
        };
    }
    var appendedRows = AlldgRows.getValues('RowAppend', true);
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    var rowIndex = 0;
    appendedRows.map(function ( el, i) {
        if (el.id == SelectedData.id && el.sortorder == SelectedData.sortorder) {
            rowIndex = i;
            return false;
        }
    });
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr').eq(rowIndex);
    datagridbodyRows.map(function (i, el) {
        footerData = footerDatas[i];
        if (i == 0 ) {
            var table1 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
            table1.eq(0).empty().html(table2.html());
            table1.eq(0).find('td').removeClass('datagrid_expendedcolumn');
            clearRevisionColoringInspector();
        }

        ExpandedColList[colDimension.length - 1].map(function (value) {
            var trCell = $(el).find("td[field='" + value.ColField + "']");
            var tableCell = table2.find("td[field='" + value.ColField + "']");
            if (trCell.length == 0) {
                var cell = $("<td/>").attr('field', value.ColField).attr('style', $(el).find('td').eq(0).attr('style')).css('display', tableCell.css('display'));
                //updated width for Consensus+
                // $("<div/>").attr('class', 'datagrid-cell').css('text-align', 'right').css('width', '82px').css('height', 'auto').html("").appendTo(cell);
                $("<div/>").attr('class', 'datagrid-cell').css('text-align', 'right').css('width', '101px').css('height', 'auto').html("").appendTo(cell);
                

                
                
                var seperatorIdx = $(el).find("td[field^='" + value.parameter.split('|')[0] + "']").eq(-1).index();
                if(seperatorIdx >= 0) { 
                    //expanding sources
                
                    var sourcesRow = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(MEData.column_dimensions.length - 1);
                    var sourcesOrder = [];
                    sourcesRow.find("td[field^='" + value.parameter.split("|")[0] + "']").each(function(idx, elem){
                        sourcesOrder.push( $(elem).attr('field') )
                    }) 
                    
                    var relativeIdx = sourcesOrder.indexOf(value.ColField);
                    var found = seperatorIdx;
                    for(var i = relativeIdx + 1; i < sourcesOrder.length; i++) {
                        var result = $(el).find("td[field='" + sourcesOrder[i] + "']")
                        if(result.length > 0) {
                            found = result.eq(0).index();
                            break;
                        }
                    }
                    $(el).find('td').eq(found).before(cell);
                }else{ 
                    //expanding anything other than sources
                    if (value.appendAt) { 
                        $(el).find('td').eq(value.cellPosition).before(cell);
                    } else {
                        $(el).find('td').eq(value.cellPosition).after(cell);
                    }
                }



            }

            var datav = tableCell.html();
            var trTd = $(el).find("td[field='" + value.ColField + "']");
            if (footerData && !value.parameter.toLowerCase().split('|').includes($(footerData.lineitems).text().toLowerCase().replace('+','plus'))) {
                // datav = '<div style="text-align:right;width:82px;height:auto;" class="datagrid-cell"></div>';
                //updated width for Consensus+
                datav = '<div style="text-align:right;width:101px;height:auto;float:right;" class="datagrid-cell"></div>';
                if(inspectorType != 'Peers') {
                  trTd.html(datav);
                }
                trTd.removeAttr('id');
                removeHighLowAndSurpriseColoring(trTd);
                trTd.removeAttr('class');
            }
            else {
                $(cell).addClass($(tableCell).attr('class'));
                trTd.attr("cellvalue", tableCell.attr("cellvalue"));
                trTd.html(datav);
                var params = value.parameter.toLowerCase().split('|');
                var period =params[colDimension.indexOf('period')];
                var source = params[colDimension.indexOf('source')];
                var revision = params[colDimension.indexOf('revision')];
                trTd.attr('source', source);
                trTd.attr('period', period);
                trTd.attr('dapparam_id', $(tableCell).attr('dapparam_id'));
                if ($(tableCell).attr('max') != undefined) {
                    $(trTd).attr('max', '');
                    if (high) {
                        $(trTd).addClass('high');
                    }
                }
                if ($(tableCell).attr('min') != undefined) {
                    $(trTd).attr('min', '');
                    if (low) {
                        $(trTd).addClass('low');
                    }
                }
                if ($(tableCell).attr('surprise') != undefined) {
                    $(trTd).attr('surprise', $(tableCell).attr('surprise'));
                    $(trTd).attr('title', $(tableCell).attr('title'))
                    var sliderValue = 5;
                    $.each(MEData.panels, function(idx, panel) {
                        if(panel.name.toLowerCase() === "analysis") {
                            sliderValue = panel.values[3].slider;
                        }
                    });
                    surpriseColoring($(trTd), $(tableCell).attr('surprise'), getDivisionFactorForSurprise(sliderValue));
                }
                var isNotePresent = trTd.hasClass('note-set');
                if(isNotePresent){
                    var notesObj = {
                        parameterid: SelectedData.parameterid,
                        period:period,
                        source: source,
                        revision:{
                            revision: revision ? revision :'current'
                        },
                        el: trTd
                    }
                    bindDataPointNote(notesObj);
                }
            }
            
        });
    });

    var ObjWebServiceCall = new WebServiceCall(), param_id = SelectedData.id.split("-")[0], rowObj = footerDatas;
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(2).find('tr');
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
    if ((inspectorType == "Sources" || inspectorType == "Scenarios") && colDimension.length > 1 && $.inArray('source', colDimension) > -1)
        var colArr = ExpandedColList[colDimension.length - 2]; // done to avoid sending requests for SOurces
    else
        var colArr = ExpandedColList[colDimension.length - 1];
    var periodList = [];
    $(ExpandedColList[$.inArray('period', colDimension)]).each(function (index, value){
        periodList.push(value.parameter);
    });


    // for adding consitent borders to all footer tables
    $(".datagrid-footer table").eq(0).find('td[field=lineitems]').css("border-right-width", "0px");
    $(".datagrid-footer table").eq(0).find('td[field=links]').css("border-right-width", "0px");
    $(".datagrid-footer-inner").css("border", "none");
    $(".datagrid-footer-inner .datagrid-ftable").css("border", "1px solid #ddd");
    $(".datagrid-footer-inner .datagrid-ftable").css("border-width", "1px 0px 0px 0px");


    // handling peers separately to ensure better performance and no duplicate requests fired.
     if (inspectorType == 'Peers') {
         exp_revisions = {};
         revision_idx = $.inArray('revision', colDimension);
         period_idx = $.inArray('period', colDimension);
         colArr.map(function ( value) {
             revision_str = value.parameter.split('|')[revision_idx];
             if(!revision_str){
                 revision_str = 'current';
             }
             period_str = value.parameter.split('|')[period_idx];
             if($.inArray(revision_str, Object.keys(exp_revisions)) == -1) {
                 exp_revisions[revision_str] = [period_str];
             }
             else {
                 rev_period_arr = exp_revisions[revision_str];
                 rev_period_arr.push(period_str);
                 exp_revisions[revision_str] = rev_period_arr;
             }
         })

         for (var revision_value in exp_revisions) {
                var revision_periodss = exp_revisions[revision_value];
                var revision_periods = revision_periodss.filter(function(item, pos){
                    return revision_periodss.indexOf(item)== pos;
                });
                for (var index = 0; index < filterData.length; index++) {
                    var fltrValue = filterData[index];
                    var fltData = [];
                    fltData.push(fltrValue.ticker);
                    fltData.push(fltrValue.param);
                    fltData.push(fltrValue.sources);
                    fltData.push(revision_value);
                    rev_periods = revision_periods[0];
                    for(var idx = 1; idx < revision_periods.length; idx++){
                        rev_periods = rev_periods + '&period=' + revision_periods[idx];
                    }
                    //check here
                    ObjWebServiceCall.getFooterRowData(param_id, rev_periods, inspectorType, fltData, "",
                        {"paramid": fltrValue.param, "footerRows": footerDatas, "parameterid": appendedRows[rowIndex].parameterid,"baseData": false}
                    );
                    peerCallCount++;
                };
         }
         return;
    }

    var periodExpandFlag = false;
    for (var index = 0; index < colArr.length; index++) {
        var value = colArr[index];
        var paramsSplit = value.parameter.split("|");
        var period = paramsSplit[$.inArray('period', colDimension)];
        var source = paramsSplit[$.inArray('source', colDimension)];
        if(periodList.includes(period) && //check period is present in periodList
            ( value.parameter.includes('current') || !colDimension.includes('revision') ) // check revision dimension is on or not
            && ( source == 'consensus' // check whether source is consensus or not
                || inspectorType == "Sources" || inspectorType == "Scenarios" ) 
            && periodExpandFlag){
            continue;
        }
        var actionFlag = true;
        filterData.map(function (d, valuefilterData) {
            if ($.inArray(valuefilterData, value.parameter.split('|')) != -1) {
                actionFlag = false;
                return;
            }
        });
        if (actionFlag == false)
            continue;

        var revision;
        //append periods of periodList if periods are expanded
        if ($.inArray('period', colDimension) != -1) {
            period = paramsSplit[$.inArray('period', colDimension)];
            revision = 'current';
            if (period.length > 7){
                if($.inArray('revision', colDimension) != -1){
                    if(paramsSplit[$.inArray('revision', colDimension)] != 'current'){
                        revision = paramsSplit[$.inArray('revision', colDimension)];
                    }
                }
                if(revision == 'current' && (paramsSplit[$.inArray('source', colDimension)] == 'consensus'
                    || inspectorType == "Sources" || inspectorType == "Scenarios") && !periodExpandFlag){
                    periodExpandFlag = true;
                    periodList.map(function (val){
                        if(!period.includes(val))
                            period = period + '&period=' + val;
                    });
                }
            }
        }
        if ($.inArray(value.parameter, baseFooterColumns[inspectorType]) > -1)
            ObjWebServiceCall.getFooterRowData(param_id, period, inspectorType, filterData, value.parameter, {
                "paramid": param_id,
                "parameterid": appendedRows[rowIndex].parameterid,
                "footerRows": footerDatas,
                "baseData": false
            });
        else {
            baseFooterColumns[inspectorType].push(value.parameter);
            ObjWebServiceCall.getFooterRowData(param_id, period, inspectorType, filterData, value.parameter, {
                "paramid": param_id,
                "parameterid": appendedRows[rowIndex].parameterid,
                "footerRows": footerDatas,
                "baseData": true
            });
        }
    };
}
function InspectorClick(flag, title, from) {
    const footerLoaded = $(".tblInsSpan").text() !== "";
    if(!footerLoaded) {
        return;
    }

    var footerInsTabs = $('.datagrid-view2 .datagrid-custom-div #footerTypeDiv');
    footerInsTabs.css('padding-top', 5);

    if($('.datagrid-footer .datagrid-row').is(":visible") == true && event.target.closest(".datagrid-row-selected")){
        // for preventing api calls to fire again for selected row if inspector is open
        return false
    }
    var extraObj = {};      //creating this object to push the extra data while logging
    var action_source = '';
    if(window.keyboard_event)
        action_source = 'KEYBOARD_SHORTCUT';
    else
        action_source = 'INSPECTOR_CLICK';
    if ($('#tblIns').is(":visible") == true || title == "peers") {
        if($('#tblIns').is(':visible')) {
          $('#tt').datagrid('resize', {height: $('.datagrid-wrap').height() + $('#tblIns').height()-15});
        }

        if (flag) {
            ShowIns();
            $('#tblIns').hide();
            if(title && title == "peers"){
                inspectorType = "Peers";
            }else if(title && title == "inspector-header"){
                inspectorType = "Sources";
            }else {
                inspectorType = title || "Lineitem";
            }

            if(from != "peers"){
                LoadDatagridFooterData(0, inspectorType);
            }else{
                LoadDatagridFooterData(0, inspectorType, false, 'peers');
            }


            //created this variable to get list of sources present in expansions
            var inspectorSourceList = getSourceExpansion();
            //created this variable to get list of sources participating in custom consensus calculations
            var includedSourcesinCC = getIncludedBrokers();
            if(window.gSource) {
                //Manually pushing the focussed source in the array
                inspectorSourceList.push(window.gSource);
            }
            extraObj['state'] = 'SHOW';
            extraObj['sourceList'] = inspectorSourceList;
            extraObj['ccSourceList'] = includedSourcesinCC;
            var unentitledSourceInfo = getUnentitledSourceInfo();
            $.extend(extraObj, unentitledSourceInfo);
            dummyAjaxRequest(company, cut, 'INSPECTOR_EXPAND', extraObj, '', action_source);
        }
        var scL = $('div.datagrid-body').eq(1)[0].scrollLeft;
        $('div.datagrid-body').eq(1).scrollLeft(scL + 10);
        $('div.datagrid-body').eq(1).scrollLeft(scL);
    }
    else {
        $('#tblIns').show();
        if(flag === true) {   //Added this so that when SAR view is loaded, log is not fired for a HIDE_INSPECTOR
            extraObj['state'] = 'HIDE';
            dummyAjaxRequest(company, cut, 'INSPECTOR_COLLAPSE', extraObj, '', action_source);
        }
        HideIns();
    }
    reziseGridPanel();
}
function displayInspectorInfo(metadata) {
    var filterObjs = metadata.panels.getValues('type', 'off').concat(metadata.panels.getValues('type', 'filter'));
    var infoText = [];
    for(var i=0; i<filterObjs.length; i++){
        var el = filterObjs[i];
        if (el.name == 'Scenarios')
            infoText.push(window.gScenario);
        else if (el.name == 'Adjustments')
            infoText.push(window.gAdjust);
        else if (el.name == "Accounting basis")
            infoText.push(getSelected(el.values));
        else if (el['default'] != "")
            infoText.push(el['default']);
    };
    if (infoText.length == 0)
        infoText = [metadata.ticker, metadata.variant]
    $('.inspDiv').text("Displaying: " + infoText.join(', '));
}
function footerTypes() {
    var inspectorObj = MEData.inspector;
    var Div = '<div id="footerTypeDiv">';
    var tdDivs = "";
    inspectorObj.values.map(function (val) {
        var tempDiv1 = '<div id="Td' + val.type + '" class="fstdInsp">';
        var tempDiv2 = '<div onclick="LoadDatagridFooterData(0,\'' + val.type + '\', false, \'tabClick\');">' + val.name + '</div></div>';
        if (val.type == MEData.inspector['default'])
            tempDiv1 = tempDiv1.replace('fstdInsp', 'fstdInspclick');
        tdDivs += tempDiv1 + tempDiv2;
    });
    Div = Div + tdDivs + "</div>";
    return Div;
}

function LoadFooterWithLineItemDetails(type) {
    var selected = $('#tt').datagrid('getSelected');

    if(selected.id.toLowerCase().startsWith("dummy")) {
        cleanUpInspector();
        return;
    }

    displayLineitem(selected);

    $("#footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
    $("#Td" + type).attr("class", "fstdInspclick fstddivclick");
    $(".datagrid-footer").height("120px");
    $('.datagrid-body').height($('.datagrid-wrap').height() - $(".datagrid-footer").height() - $('.datagrid-header').height() - $('.datagrid-custom-div').height() + 33);
    $(".datagrid-view2 .settingDiv2").hide();
    $(".datagrid-view1 #customDiv1 div").eq(1).hide();  
    //apply make footer-inner to take full space
    $('.datagrid-footer-inner').css('width', '100%');
    $('.datagrid-footer-inner table tr').remove();

    
    var footerLeft = $('.datagrid-view1 .datagrid-footer-inner');
    var footerRight = $('.datagrid-view2 .datagrid-footer-inner');
    var totalWidth = footerLeft.width() + footerRight.width();
    
    //if height is 0. give a height of 120
    var totalHeight = footerLeft.height() < 1 ? 120 : footerLeft.height();

    
    $('.line-item-details-parent-container').remove();
    var styleLineitemParentContainer = "position: fixed; overflow: auto; height: " + totalHeight + "; width: " + totalWidth + "px;"
    var styleLineitemContainer = "padding: 12px; display: flex; height: 110px; width:900px; background: #fff;"
    
    footerLeft.after($("<div style='" + styleLineitemParentContainer + "' class='line-item-details-parent-container'><div class='line-item-details-container' style='" + styleLineitemContainer + "'></div></div>"));
    
    var columns = $("<div class='column-left' style='display: flex; flex-direction: column;'></div><div class='column-right' style='display: flex; flex-direction: column; margin-left: 130px;'></div>");
    $('.line-item-details-container').append(columns);
    
    var shortToFullName = {
        NMV: 'Company',
        STD: 'Standardized',
        SCH: 'Schedule'
    };

    var currentLineitemType = shortToFullName[window.cut];
    createLineItemDetail( currentLineitemType + ' Data Name', selected.name);
    createLineItemDetail( currentLineitemType + ' Data Excel Code', selected.id.match(/\d*/));
    
    if(window.cut === 'SAR') {
        $(".line-item-details-parent-container").hide();
        $('.datagrid-body').height($('.datagrid-wrap').height() - $('.datagrid-header').height());
        return;
    }

    var addStdMappingsToInspector = function(nmvSliMappings) {
        nmvSliMappings.forEach(function(item) {
            createLineItemDetail('Standardized Data Name', item[1]);
            createLineItemDetail('Standardized Data Excel Code', item[0]);
        });
    }
    if(window.cut === 'NMV' && selectedLineStdAndCompDict[window.pg + selected.param_id]) {
      addStdMappingsToInspector(selectedLineStdAndCompDict[window.pg + selected.param_id].stdMappings);
    }
    
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() - 1);
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + 1);
    $('.datagrid-view2 .datagrid-footer').css('display', 'none');
    window.inspectorType = "Lineitem";
}

function LoadFooterWithComptable(index, type, logEvent, from) {
    var selected = $('#tt').datagrid('getSelected');

    if(selected.id.toLowerCase().startsWith("dummy")) {
        cleanUpInspector();
        return;
    }

    displayLineitem(selected);

    $("#footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
    $("#Td" + type).attr("class", "fstdInspclick fstddivclick");
    $(".datagrid-footer").height("120px");
    $('.datagrid-body').height($('.datagrid-wrap').height() - $(".datagrid-footer").height() - $('.datagrid-header').height() - $('.datagrid-custom-div').height() + 33);
    $(".datagrid-view2 .settingDiv2").hide();
    $(".datagrid-view1 #customDiv1 div").eq(1).hide();  
    //apply make footer-inner to take full space
    $('.datagrid-footer-inner').css('width', '100%');
    $('.datagrid-footer-inner table tr').remove();

    var footerLeft = $('.datagrid-view1 .datagrid-footer-inner');
    var footerRight = $('.datagrid-view2 .datagrid-footer-inner');
    var totalWidth = footerLeft.width() + footerRight.width();
    
    //if height is 0. give a height of 120
    var totalHeight = footerLeft.height() < 1 ? 120 : footerLeft.height();

    $('.line-item-details-parent-container').remove();
    $('.comptable-parent-container').remove();
    var styleComptableParentContainer = "position: fixed; height: " + totalHeight + "; width: " + totalWidth + "px;"
    var styleComptableContainer = "height: 110px; width:100%; background: #fff;"
    
    footerLeft.after($("<div style='" + styleComptableParentContainer + "' class='comptable-parent-container'><div class='comptable-container' style='" + styleComptableContainer + "'></div></div>"));
    $('.comptable-container').append("<div class='table-header'></div>");
    $('.comptable-container').append("<div class='table-content' style='height: calc(100% - 26px); overflow: auto'></div>");

    createComptableMappingHeader();

    var populateComptables = function (compTables) {

        if(compTables.length === 0) {
            window.inspectorType = 'Lineitem';
            LoadDatagridFooterData(index, window.inspectorType, logEvent, from);
            return;
        }

        compTables.forEach(function(compTable) {
            createComptableLine(compTable);
        });
    }
    
    var fetchComptableMappings = function (stdMappings) {
        var uniqueSliIds = stdMappings.map(function(stdMapping){ return stdMapping[0]; });
        if(uniqueSliIds.length > 0) {
            getComptableMappings(window.MEData.companyid, uniqueSliIds, populateComptables);
        }else {
            populateComptables([]);
        }
    }
    
    if(window.cut === 'NMV' && selectedLineStdAndCompDict[window.pg + selected.param_id]
      && !selectedLineStdAndCompDict[window.pg + selected.param_id].comptableMappings
    ) {
      fetchComptableMappings(window.usliIds[selected.param_id] || []);
    }else if(window.cut === 'NMV' && selectedLineStdAndCompDict[window.pg + selected.param_id]
      && selectedLineStdAndCompDict[window.pg + selected.param_id].comptableMappings
    ) {
        populateComptables(selectedLineStdAndCompDict[window.pg + selected.param_id].comptableMappings);
    }else if (window.cut === 'STD' && !selectedLineStdAndCompDict[window.pg + selected.param_id]) {
        fetchComptableMappings([[selected.param_id]]); //paramid is the sli id for STD view
    }else if (window.cut === 'STD' && selectedLineStdAndCompDict[window.pg + selected.param_id]) {
        populateComptables(selectedLineStdAndCompDict[window.pg + selected.param_id].comptableMappings);
    }
    
    
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() - 1);
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + 1);
    $('.datagrid-view2 .datagrid-footer').css('display', 'none');
    window.inspectorType = "Comptable";
}

function LoadFooterWithPeers(index, type) {
    inspectorType = type;
    var selected = $('#tt').datagrid('getSelected');
    if (selected == null) {
        var dgRows = $('#tt').datagrid('getRows');
        selected = dgRows[index];
    }
    var usliIds = null;
    var param_id = selected.id.split("-")[0];
    if(cut == "STD") {
      usliIds = [param_id]
    } else {
      usliIds = window.usliIds[param_id]
    }
    if ($.inArray(param_id, MEData.row_dimensions[0].values.getValues('header', true).getKeyValues('id')) > -1) {
        var dgRows = $('#tt').datagrid('getRows');
        param_id = MEData.row_dimensions[0].values.getValues('header', undefined).getKeyValues('id')[0];
        for (var i = 0; i < dgRows.length; i++) {
            var el = dgRows[i];
            if (el.id.split("-")[0] == param_id) {
                selected = el;
                $('#tt').datagrid('selectRow', i);
                break;
            }
        };
    }
    $("#footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
    $("#Td" + type).attr("class", "fstdInspclick fstddivclick");

    var ObjWebServiceCall = new WebServiceCall();
    ObjWebServiceCall.getPeerCompanies(param_id, usliIds, selected);
}
var peerData = [];
var peerCallCount = 0;
// function removeBrokers(sources) {
//   var panelObj = $.grep(window.MEData.panels, function (n, i) {
//     if (n.name == "Sources") return true;
//   });
//   var brokersT = $.grep(panelObj[0].values, function (n, i) {
//       if (n.name == "Brokers") return true;
//   });
//   var brokers = brokersT[0].values
//   for(var i =0; i< brokers.length; i++) {
//     var idx = sources.findIndex(function(val) {
//       return val === brokers[i].name;
//     })
//     if(idx > -1) {
//       sources.splice(idx, 1)
//     }
//   }
//   return sources;
// }
function onSuccessLoadPeers(response, selectedObj) {
    var paramId = selectedObj.id.split("-")[0];
    selectedObj.paramid = selectedObj.param_id;
    var className = '';
    var tickers = [];
    var paramIds = [];
    var ticker_list = [];
    var periodList = MEData.column_dimensions.filter(function(data){
        return data.name == "periods";
    })[0].values;
    var sources = GetFilterData('Sources',selectedObj.name).FilterData;
    sources.shift(); // removed 1st element as it has line item name
    // if brokers are selected but not included in columns, i.e. they are included in rows,
    // then don't fetch data for them, as it overrides data of same period in peers tab
    // if(colDimension.findIndex((col) => col === 'source') === -1) {
    //   sources = removeBrokers(sources);
    // }

    var footerrows = [];

    if(response.findIndex((obj) => obj.ticker == company) == -1){
        response.unshift({'ticker': MEData.ticker, name: MEData.company_name});
    }
    for (var index = 0; index < response.length; index++) {
        var peerObj = response[index];
        var ticker = peerObj.ticker;
        var tickerFullName = peerObj.name;
        footerrows.push({
            lineitems: '<b ' + className + 'id="' + selectedObj.param_id + '_' + ticker.toLowerCase() +'" ' + 'title="' + ticker + ": " + tickerFullName + '">' + ticker + "</b>",
            id: selectedObj.param_id + ticker.toLowerCase()
        });

        tickers.push({'ticker' : ticker, 'param' :  selectedObj.param_id, 'name': ticker,
            'sources': sources, 'param_name': ticker });

        if($.inArray(ticker, ticker_list) == -1){
            ticker_list.push(ticker);
        }
        ticker_list.map(function(val){
            if($.inArray(val, Object.keys(note_dict_peer)) == -1 && val != company){
                note_dict_peer[val] = undefined;
            }
        });
    };
    peerData['tickers'] = tickers;
    footerRowDimension = [];
    //display lineitem on inspector
    displayLineitem(selectedObj);
    $('#tt').datagrid('reloadFooter', footerrows);
    $('.datagrid-view1').find('td[field="lineitems"]').children().css('min-width','240px');
    var footerHeight = Math.min(parseInt($(".datagrid-footer-inner").height()), 120);
    $(".datagrid-footer").height(footerHeight + "px");
    $('.datagrid-footer').find('td[field="lineitems"]').eq(0).width('100%');
    $('.datagrid-body').height($('.datagrid-wrap').height() - $(".datagrid-footer").height() - $('.datagrid-custom-div').height() - $('.datagrid-header').height());
    dynamicFooterHeight = $('.datagrid-footer').height();
    footerRowDimension.push("lineitem");
    footerRowDimension.push("ticker");
    var ObjWebServiceCall = new WebServiceCall();
    var rowindex = baseParamIndex(true, paramId);
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
    var dataTr = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr').eq(rowindex);
    var footerTr = table2.eq(0).empty().html(dataTr.html());
    table2.eq(0).find('td').removeClass('datagrid_expendedcolumn');

    var footerPeriods = periods.join('&period=');
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() - 1);
    $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + 1);

    var yo_tickers = peerData.tickers;

    var periodList = MEData.panels.filter(function(data){
        return data.name == "periods"
    })[0];
    var selectedFromYr = Number(periodList.selected_from.split("-")[1].replace('E',''));
    var selectedToYr = Number(periodList.selected_to.split("-")[1].replace('E',''));

    var featurePeriods = periodList.all_period_expansion_list.filter(function(val){
        var valYr = Number(val.period.split("-")[1]);
        return val.forecast == true && valYr >= selectedFromYr && valYr <= selectedToYr
    }).map(function(data){
        return data.period
    });

    var actualPeriods = periodList.all_period_expansion_list.filter(function(val){
        var valYr = Number(val.period.split("-")[1]);
       return val.forecast == false && valYr >= selectedFromYr && valYr <= selectedToYr
    }).map(function(data){
        return data.period
    });
    for(var i=0; i<2; i++){ // for Actual and Feature periods

        for (var index = 0; index < yo_tickers.length; index++) {
            var value = yo_tickers[index];
            var fltData = [];
            fltData.push(value.ticker);
            fltData.push(value.param);
            fltData.push(value.sources);
            fltData.push('current');
            ObjWebServiceCall.getFooterRowData(paramId, footerPeriods, inspectorType, fltData, "",
                {
                    "paramid": value.param, 
                    "footerRows": footerrows, 
                    "baseData": false, 
                    "parameterid": selectedObj.parameterid,
                    callFor : "Peers"
                }, featurePeriods, actualPeriods, i);
            peerCallCount++;
        };
    }

    GetLIColsExpandedValue();
}

function cleanUpInspector(gridRefresh) {
    //clear up inspector
    const footer = document.querySelector("#tblIns");
    const inspectorCollapsed = (footer && footer.offsetParent) ? footer.offsetParent : null;
    if (inspectorCollapsed === null) {
      //collapse inspector
      const inspector = document.querySelector("#tblIns div");
      if (inspector) {
        inspector.click();
      }
    }

    document.querySelectorAll(".tblInsSpan").forEach((elem) => {
      elem.textContent = "";
    });

    $("#tblIns #footerTypeDiv").remove();
    $(".datagrid-view2 #footerTypeDiv").css("visibility","hidden");
    $(".line-item-details-parent-container").remove();
    $(".comptable-parent-container").remove();
  }